import { createApiRequest } from "@/lib/api/createApiService";
import { CUSTOM_DISCLOSURE_ENDPOINTS } from "./custom-disclosure.endpoints";

export const customDisclosureService = {
  // List custom disclosures
  list: async (params = {}, options = {}) => {
    return createApiRequest({
      url: CUSTOM_DISCLOSURE_ENDPOINTS.LIST,
      method: "GET",
      body: params,
      ...options,
    });
  },

  // Get single
  get: async (id, options = {}) => {
    return createApiRequest({
      url: CUSTOM_DISCLOSURE_ENDPOINTS.GET(id),
      method: "GET",
      ...options,
    });
  },

  // Create
  create: async (data, options = {}) => {
    return createApiRequest({
      url: CUSTOM_DISCLOSURE_ENDPOINTS.CREATE,
      method: "POST",
      body: data,
      ...options,
    });
  },

  // Update
  update: async (id, data, options = {}) => {
    return createApiRequest({
      url: CUSTOM_DISCLOSURE_ENDPOINTS.UPDATE(id),
      method: "PUT",
      body: data,
      ...options,
    });
  },

  // Delete
  delete: async (id, force = false, options = {}) => {
    return createApiRequest({
      url: `${CUSTOM_DISCLOSURE_ENDPOINTS.DELETE(id)}${force ? "?force=true" : ""}`,
      method: "DELETE",
      ...options,
    });
  },

  // Archive
  archive: async (id, options = {}) => {
    return createApiRequest({
      url: CUSTOM_DISCLOSURE_ENDPOINTS.ARCHIVE(id),
      method: "PATCH",
      ...options,
    });
  },

  // Restore
  restore: async (id, options = {}) => {
    return createApiRequest({
      url: CUSTOM_DISCLOSURE_ENDPOINTS.RESTORE(id),
      method: "PATCH",
      ...options,
    });
  },

  // Clone
  clone: async (id, options = {}) => {
    return createApiRequest({
      url: CUSTOM_DISCLOSURE_ENDPOINTS.CLONE(id),
      method: "POST",
      ...options,
    });
  },

  // Set template status
  setTemplate: async (id, isTemplate, options = {}) => {
    return createApiRequest({
      url: CUSTOM_DISCLOSURE_ENDPOINTS.SET_TEMPLATE(id),
      method: "PATCH",
      body: { isTemplate },
      ...options,
    });
  },

  // Get templates
  getTemplates: async (options = {}) => {
    return createApiRequest({
      url: CUSTOM_DISCLOSURE_ENDPOINTS.TEMPLATES,
      method: "GET",
      ...options,
    });
  },

  // Bulk archive
  bulkArchive: async (ids, options = {}) => {
    return createApiRequest({
      url: CUSTOM_DISCLOSURE_ENDPOINTS.BULK_ARCHIVE,
      method: "POST",
      body: { ids },
      ...options,
    });
  },

  // Bulk delete
  bulkDelete: async (ids, force = false, options = {}) => {
    return createApiRequest({
      url: `${CUSTOM_DISCLOSURE_ENDPOINTS.BULK_DELETE}${force ? "?force=true" : ""}`,
      method: "POST",
      body: { ids },
      ...options,
    });
  },

  // Get usage
  getUsage: async (id, options = {}) => {
    return createApiRequest({
      url: CUSTOM_DISCLOSURE_ENDPOINTS.USAGE(id),
      method: "GET",
      ...options,
    });
  },

  // Get analytics
  getAnalytics: async (options = {}) => {
    return createApiRequest({
      url: CUSTOM_DISCLOSURE_ENDPOINTS.ANALYTICS,
      method: "GET",
      ...options,
    });
  },
};
